var XPortal = XPortal || {};
XPortal.Comments = (function () {
    var self = {
        controlSelector: ".comments-cntbc",
        dictkeys: [
            "XFAdvanceComments.Delete.ConfirmTitle", "XFAdvanceComments.Delete.ConfirmBody", "XFAdvanceComments.Reply.Template", "XFAdvanceComments.Total.Template",
            "XFAdvanceComments.OrderBy.Newest", "XFAdvanceComments.OrderBy.Oldest", "XFAdvanceComments.OrderBy.AuthorAZ", "XFAdvanceComments.OrderBy.AuthorZA"
        ],
        dictvals: {},
        replyRegex: /^\s*(\@\w*)\s+/gm,
        urlRegex: /((?:https?:\/\/|www\.)[^\s<'"]+)/gi, // quotes excluded: they'd break out of the href attribute
        avatars: {},
        items: {},
        maxLevel: 3,
        saveAttachmentsUrl: '/umbraco/Surface/Comments/AddAttachments',
        Init: function (container) {
            container = container ? container : $("body");
            loadLocalizations();
            container.find(self.controlSelector).each(function (i, element) {
                self.initFor($(element));
            });
        },
        initFor: function (el) {
            if (el.data("processed")) return;
            el.data("processed", true);
            try {
                const sttgs = getDataModelFor(el);
                if (sttgs.isattachmentsenabled && !el.find(".xpand-upload-files").data("kendoUpload"))
                    XPortal.UploadFiles.Init(el);



                const $closestSection = el.closest('.xsection');
                const $commentSectionParent = $closestSection.hasClass('xdetailssection') ? $closestSection.parents('.xgridpagesection') : $closestSection;
                const isSectionCollapsible = $commentSectionParent.hasClass('collapsible');
                let $bindEl = el;
                // on grid page structure differst form detail page
                if (isSectionCollapsible && $commentSectionParent.length > 0) {
                    moveSortToTitle(el);
                    $bindEl = $commentSectionParent.length > 0 ? $commentSectionParent : el;
                }
                // on detail page structure differst form grid page
                if ($closestSection.hasClass('collapsible')) {
                    moveSortToTitle(el);
                    $bindEl = $closestSection.length > 0 ? $closestSection : el;
                }
                kendo.bind($bindEl, sttgs.data);
                refreshDataSource($bindEl, sttgs);
                $bindEl.find(".auto_height").each((xi, x) => autoHeight($(x)));
            } catch (ex) {
                console.log("can't construct comments block, error: " + ex);
            }
        },
        HandleShowMoreAppearance: function ($el) {
            setTimeout(() => {
                handleShowMoreAppearance($el);
            }, 200);
        },
        ImageField: function (data, fsttgs, nodeid) {
            const fval = XPortal.Template.GetObjPropValueByName;
            const sttgs = XPortal.Comments.items[nodeid];
            if (fsttgs.formatString) return getFieldValue(sttgs, data, fsttgs);
            if (fsttgs.formatExtended && fsttgs.formatExtended.Method) {
                const f = new Function('item', 'dtype', 'dfield', 'inFormat', 'nodeId', 'htmlTemplate', 'fOpts', 'return ' + fsttgs.formatExtended.Method + '(item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts);');
                return f(data, fsttgs.type, fsttgs.field, null, nodeid, '', fsttgs);
            }
            const v = fval(data, fsttgs.field);
            debug("render-image: " + fsttgs.field + ": " + v, data);
            fsttgs.noImageUrl = fsttgs.noImageUrl ? fsttgs.noImageUrl : "/content/images/empty-content-view-item.png";
            const iurl = v == null ? fsttgs.noImageUrl : encodeURIComponent(v);
            let ialias = fval(data, "alias");
            ialias = ialias ? ialias : fval(data, "entityalias");
            const purl = v == null ? iurl : "/umbraco/Surface/Detail/ImageAltr?i=" + fval(data, "UniqueId") + "&a=" + ialias + "&src=&cnfr=1&file=" + iurl + "&f=Image&altr=" + fsttgs.noImageUrl;
            const r = $("<img/>");
            r.attr("src", purl);
            r.attr("alt", fsttgs.title);
            return $("<div/>").append(r).html();
        },
        SimpleField: function (data, fsttgs, nodeid) {
            const sttgs = XPortal.Comments.items[nodeid];
            if (fsttgs.formatExtended && fsttgs.formatExtended.Method) {
                const f = new Function('item', 'dtype', 'dfield', 'inFormat', 'nodeId', 'htmlTemplate', 'fOpts', 'return ' + fsttgs.formatExtended.Method + '(item, dtype, dfield, inFormat, nodeId, htmlTemplate, fOpts);');
                return f(data, fsttgs.type, fsttgs.field, null, nodeid, '', fsttgs);
            }
            const v = getFieldValue(sttgs, data, fsttgs);
            return v ? v : '';
        },
        ActionTitle: function (data, fsttgs, nodeid, stitle, htitle) {
            const state = !data["toggle" + fsttgs.Code];
            const title = state
                ? (stitle ? XPortal.Template.TemplateToHtml(fsttgs, stitle) : fsttgs.title)
                : (htitle ? XPortal.Template.TemplateToHtml(fsttgs, htitle) : fsttgs.htitle || fsttgs.title);
            return XPortal.Template.TemplateToHtml(data, decodeURIComponent(title));
        },
        SaveAttachments: function (e, $commentForm, isAllFilesUploaded, onError) {
            XPortal.Loader.show({ showDelayTime: 2000, 'selector': null, showOverlay: true });
            var $commentBlock = $commentForm.closest(self.controlSelector);
            var nodeId = $commentBlock.attr("data-nid");
            let files = _.map(e.files, function (f) {
                var fnamelcase = $("<div>&nbsp;</div>").html(f.name).text().toLowerCase();
                f.response = _.find(e.response.Files, function (df) {
                    return df.src.toLowerCase() == fnamelcase;
                });
                f.dst = !(f.response) ? null : f.response.dst;
                if (f.dst && f.dst.length > 0) {
                    f.existing = 1;
                    return { AttachedFile: f.dst, FileName: f.name, FileSize: f.size, FileExtension: f.extension };
                }
                return null;
            });
            files = files.filter(x => x);
            const commentItem = e.response.Result.Item || {};
            const sttgs = XPortal.Comments.items[nodeId];
            var postData = { files, nodeId, commentId: commentItem.UniqueId, parentInfo: sttgs.parentInfo };
            XPortal.Utils.APIPost(self.saveAttachmentsUrl, postData)
                .then(function (result) {
                    if (result.State < 0) {
                        showError();
                        if (onError) onError();
                    }
                    refreshDataSource($commentBlock, sttgs);
                })
                .fail(function (jqXHR, textStatus) {
                    showError();
                    console.error("Unable to save comment attachments!" + textStatus, { e: jqXHR });
                    if (onError) onError();
                });
        }
    };
    function showError(titleKey, bodyKey) {
        titleKey = titleKey || "XFModal.Error.Title";
        bodyKey = bodyKey || "XFModal.Error.Comment.Attachment.Body";
        XPortal.Localization.GetLocalizedStrings(titleKey, bodyKey).then(function (items) {
            XPortal.EditForm.ShowErrorMessage(null, items[titleKey], items[bodyKey]);
        });
    };
    function getDataModelFor(el, modelName) {
        const xs = XPortal.Main.GetSettingsFor(el);
        const sttgs = Object.assign(XPortal.Utils.readJsonStr(xs.stgs), { parentInfo: xs.parentInfo, urladd: xs.urladd, urldel: xs.urldel, urlget: xs.urlget, urlnotify: xs.urlnotify, urlavatars: xs.urlavatars, urlattachs: xs.urlattachs, gettimeout: [] });
        const templateIds = getTemplates(el, sttgs);
        sttgs.data = kendo.observable({
            id: sttgs.id, nodeid: sttgs.nodeid, imodelName: modelName, Items: [], isEmpty: true, isNotEmpty: false, total: 0, mainQuery: "", pageIndex: 0, pageSize: sttgs.psize, curSort: [], curSortTitle: "", orderBy: sttgs.orderBy,
            activeViews: templateIds, activeView: templateIds[0],
            onNewKeyUp: function (e) {
                const btn = $(e.currentTarget);
                autoHeight(btn);
                clearEmtyCommentError(btn);

                if (!(e.keyCode == 10 || e.keyCode == 13)) return;
                if (!(e.ctrlKey || e.altKey)) return;

                e.preventDefault();
                addNewComment(el, sttgs, getValueAndClear(e.currentTarget), e.data["UniqueId"] ? e.data : null, btn);
                $(e.currentTarget).val("");
            }, onNewClick: function (e) {
                const btn = $(e.currentTarget);
                e.preventDefault();
                addNewComment(el, sttgs, getValueAndClear(e.currentTarget), e.data["UniqueId"] ? e.data : null, btn);
                $(e.currentTarget).val("");
            }, onNewCancelClick: function (e) {
                const btn = $(e.currentTarget);
                clearEmtyCommentError(btn);
                e.preventDefault();
                replyCommentCancel(el, sttgs, e.data["UniqueId"] ? e.data : null, btn);
                $(e.currentTarget).val("");
            },
            updateOrderBy: function (e) {
                e.preventDefault();
                const btn = $(e.currentTarget);
                updateCurrentClass(e.target)
                updateSortBy(el, sttgs, e.data);
                refreshDataSource(el, sttgs);
            },
            onActionClick: e => onActionClick(e, sttgs),
            toggleShowMore: e => toggleShowMore(e)
        });

        updateSortBy(el, sttgs, sttgs.orderBy[sttgs.startUpSortIndex || 0]);
        el.data("x-settings", sttgs);
        XPortal.Comments.items[sttgs.nodeid] = sttgs;
        return sttgs;
    };
    /* -- actions-- */
    function onActionClick(e, sttgs) {
        e.preventDefault();
        const el = $(e.currentTarget);
        const a = ($(e.currentTarget).attr("data-action") || "").toLowerCase();
        if (a == "delete") deleteComment(el, sttgs, e.data);
        if (a == "notify") notifyComment(el, sttgs, e.data);
        if (a == "reply") replyComment(el, sttgs, e.data);
        if (a == "children") toggleReplies(el, sttgs, e.data);
    };
    function addNewComment(el, sttgs, cmtext, ireply, btn) {
        if (!cmtext || cmtext.length < 1) {
            showEmtyCommentError(btn)
            return;
        }

        const parent = !ireply ? null : (self.maxLevel > ireply.level ? ireply : findParent(sttgs.data.Items, ireply));
        const data = getModelToSend(sttgs, cmtext, parent ? parent.UniqueId : null);
        if (ireply) {
            replyComment(el, sttgs, ireply);
            if (ireply.togglechildren) XPortal.Utils.updateKendoObj(ireply, { togglechildren: false });
        }
        sendRequest(sttgs.urladd, data).then(data => {
            const item = data.Result.Items[0];
            const $fcnt = btn.closest(".cmnt-edit-form").find(".upload-file-container");
            const $finpt = $fcnt.find(".xpand-upload-files");

            if ($finpt.length) {
                const kupl = $finpt.data("kendoUpload");
                const urlParts = kupl.options.async.saveUrl.split('?');
                const params = new URLSearchParams(urlParts[1]);
                params.set('i', item.UniqueId);
                params.set('a', item.EntityAlias);
                params.set('src', sttgs.nodeid);
                kupl.options.async.saveUrl = `${urlParts[0]}?${params.toString()}`;
                kupl.upload();
            }

            refreshDataSource(el, sttgs, parent);
            XpandUploadControl.prototype.updateDropzoneClass($('.dropzone-container'), 0)
            XpandUploadControl.prototype.clearCountError($('.dropzone-container'), 0)
        }, errArgs => {
            console.log("can't add new comment, error", errArgs);
            refreshDataSource(el, sttgs, null, 1);
        });
    };
    function deleteComment(el, sttgs, idata) {
        const data = getModelToSend(sttgs, moment().format(), null, idata.UniqueId);

        let headerText = self.dictvals["XFAdvanceComments.Delete.ConfirmTitle"];
        XPortal.Modal.confirm({ options: { showModal: true, IsForm: true, confirmationText: self.dictvals["XFAdvanceComments.Delete.ConfirmBody"], headerText, buttonsText: "" } }, function (e) {
            if (e.result === "no") return;
            sendRequest(sttgs.urldel, data).then(data => {
                const parent = findParent(sttgs.data.Items, idata);
                refreshDataSource(el, sttgs, parent === true ? null : parent);
            }, errArgs => {
                console.log("can't remove comment, error", errArgs);
                refreshDataSource(el, sttgs);
            });
        });
    };
    function notifyComment(el, sttgs, idata) {
        const data = getModelToSend(sttgs, moment().format(), null, idata.UniqueId);
        sendRequest(sttgs.urlnotify, data).then(data => {
            refreshDataSource(el, sttgs, idata);
        }, errArgs => {
            console.log("can't toggle notify comment, error", errArgs);
            refreshDataSource(el, sttgs, idata);
        });
    };
    function replyComment(el, sttgs, idata) {
        const isReading = !idata.isReading;
        XPortal.Utils.updateKendoObj(idata, {
            isReading, isReplaing: !isReading, count: idata.count
        });
        setTimeout(function () {
            const $replyEl = el.closest(".comment-item").find(".reply-control ").first();
            const rel = $replyEl.find("input, textarea").first();
            if (self.maxLevel <= idata.level)
                rel.val(XPortal.Template.TemplateToHtml(idata, self.dictvals["replytemplate"]) + " ");
            else
                rel.val("");
            rel.focus();
            el.closest(".comment-item").find(".auto_height").each((xi, x) => {
                autoHeight($(x));
            });
            if (sttgs.isattachmentsenabled && $replyEl.find(".xpand-upload-files").length && !$replyEl.find(".xpand-upload-files").data("kendoUpload")) {
                updateDZoneSelectorWithUniqueId($replyEl, idata);
                XPortal.UploadFiles.Init($replyEl);
            }
        }, 250);
    };
    function updateDZoneSelectorWithUniqueId($replyEl, idata) {
        $replyEl.each((ix, x) => {
            const $dzone = $(x).find(".dropzone-container_comments")
            const newId = $dzone.attr('id') + "_" + idata.level + "_" + idata.uniqueid.slice(0, 8);
            $dzone.attr('id', newId);
            $dzone.find(".xpand-upload-files").attr('data-dropzone-selector', "#" + newId);
        });
    }
    function replyCommentCancel(el, sttgs, idata) {
        replyComment(el, sttgs, idata);
    }
    function toggleReplies(el, sttgs, idata) {
        XPortal.Utils.updateKendoObj(idata, { togglechildren: idata["togglechildren"] ? false : true });
        refreshItemsInTree(sttgs.data.Items, idata);
        // refreshDataSource(el, sttgs, idata);
        setTimeout(() => {
          handleShowMoreAppearance(el);
        }, 1000);
    };
    function updateSortBy(el, sttgs, data) {
        const sortParts = data.value.split("_");
        const curSort = [{ name: sortParts[1], dir: sortParts[0] }];
        sttgs.data.curSort = [];
        XPortal.Utils.updateKendoObj(sttgs.data, { curSort, curSortTitle: data.title });
        sttgs.data.orderBy.forEach(x => {
            XPortal.Utils.updateKendoObj(x, { isActive: data.value == x.value, isNotActive: data.value != x.value });
        });
    };
    function moveSortToTitle(controlSelector, sttgs) {
        const $el = controlSelector;
        const $closestSection = $el.closest('.xsection');
        let $commentSectionParent = $closestSection.hasClass('xdetailssection') ? $closestSection.parents('.xgridpagesection') : $closestSection;
        // on detail page structure differs from grid page
        if ($closestSection.hasClass('collapsible')) {
            $commentSectionParent = $closestSection;
        }
        const $commentSectionHeader = $commentSectionParent.find('>.xbgdecoration-wrap >.block-header');
        const $commentSectionHeaderTitle = $commentSectionHeader.find('.block-header__title-wrp');
        const isTabSection = $commentSectionParent.hasClass('xsection-tab');
        if (isTabSection) return;
        const $commentsSummary = $el.find('.comments-cntbc__summary');
        const $commentsSummaryTitle = $commentsSummary.find('.block-header-title');
        if ($commentsSummaryTitle.length > 0) return;
        const $commentsSummaryDropdown = $commentsSummary.find('.dropdown');
        const dropdown = `<div class="dropdown">
                            <span class="dropdown-toggle" role="button" data-toggle="dropdown" data-bind="html:curSortTitle"></span>
                            <ul class="comments-order dropdown-menu" data-bind="source: orderBy" data-template="commentsOrderBy">
                            </ul>
                        </div>`;
        $commentSectionHeaderTitle.find('.dropdown').remove();
        $commentSectionHeaderTitle.append(dropdown);
        $commentSectionHeader.addClass('with-comments-dropdown');
        $commentsSummary.css('padding', '0 1rem 0');
        $commentsSummaryDropdown.addClass('d-none');
    }
    function updateCurrentClass(el) {
        $(el).parents(".dropdown-menu").find(".current").removeClass("current");
        el.parentNode.classList.add("current");
    }
    function toggleShowMore(e) {
        const el = $(e.currentTarget);
        el.parents(".entity-fld-val").toggleClass("show-cmnt");
    }
    /* ---  end actions -----------*/
    function refreshDataSource(el, sttgs, parent, timeout = 1000, loadChildren = true) {
        const parentId = parent ? parent.UniqueId : null;
        clearTimeout(sttgs.gettimeout[parentId || "_"]);
        sttgs.gettimeout[parentId || "_"] = setTimeout(function () {
            const { pageIndex, pageSize, curSort, mainQuery, nodeid } = sttgs.data;
            const data = Object.assign({ pageIndex, sort: curSort.map(x => { return { name: x.name, dir: x.dir || "asc" }; }), nodeid, keywords: mainQuery, parentInfo: sttgs.parentInfo, parentId });
            XPortal.Loader.show({ showDelayTime: 2000, 'selector': null, showOverlay: true });
            processAllPages(sttgs.urlget, data, parent, dres => {
                const refreshComments = (dres, avatarsToLoad, attachs) => {
                    const items = convertToHierarchy((dres.Result.Items || []).map(x => mapCommentItem(x, sttgs, avatarsToLoad, attachs)), sttgs);
                    sttgs.data.total = dres.Result.TotalItems;
                    const isEmpty = sttgs.data.total < 1;
                    if (parent == null)
                        XPortal.Utils.updateKendoObj(sttgs.data, { total: XPortal.Template.TemplateToHtml(sttgs.data, self.dictvals["totaltemplate"]), Items: items, isEmpty, isNotEmpty: !isEmpty });
                    else {
                        XPortal.Utils.updateKendoObj(parent, { SItems: items, count: items.length, hidechildren: items.length < 1 });
                        XPortal.Utils.updateKendoObj(sttgs.data, { total: XPortal.Template.TemplateToHtml(sttgs.data, self.dictvals["totaltemplate"]), isEmpty, isNotEmpty: !isEmpty });
                        refreshItemsInTree(sttgs.data.Items, parent);
                        items.forEach(ix => loadChildren ? refreshDataSource(el, sttgs, ix, 1, false) : null
                        );
                    }
                    ensureAvatarsLoaded(el, sttgs, avatarsToLoad);
                    setTimeout(() => {
                        handleShowMoreAppearance(el);
                        initAttachmentSlider(self.controlSelector);
                    }, timeout);
                    XPortal.Loader.hide({ 'selector': null, showOverlay: true });
                }
                const avatarsToLoad = [];
                let items = [];
                let attachs = [];
                const dataAttachs = dres.Result.Items.map(x => items.push(x.UniqueId));
                const model = Object.assign({}, getModelToSend(sttgs), { CommentIds: items });
                if (sttgs.iswithattachments && items.length) {
                    sendRequest(sttgs.urlattachs, model).
                        then(data => { attachs = (data || {}).ResultItems || []; }).
                        finally(() => { refreshComments(dres, avatarsToLoad, attachs); },
                            errArgs => {
                                console.log("can't load comments, error", errArgs);
                            });
                }
                else {
                    refreshComments(dres, avatarsToLoad, attachs);
                }

            }).then(data => debug("all data loaded", data), errArgs => console.log("can't get comments, error", errArgs));

        }, timeout);
    };

    function mapCommentItem(item, sttgs, avatarsToLoad, attachs) {
        item = XPortal.Grid.MapEntity(item, sttgs);
        const str = '' + item.comment;
        const subst = "<span class='reply-to'>$1 </span>";
        item.comment = str.replace(self.replyRegex, subst);
        item.comment = linkifyComment(item.comment);
        item.title = $("<div/>").append(item.comment).text();
        item.cssClass = item.cssClass || '';
        item.attrs = item.attrs || '';
        item.avatar = getAvatarOrInitials(item, avatarsToLoad);
        item.attachments = getAttachments(item, attachs, sttgs);
        item.isReading = true;
        item.level = Number(item.level);
        item.count = 0;
        item.SItems = [];
        ensureActionRights(item, sttgs);
        return item;
    };

    function getAttachments(item, attachs, sttgs) {
        let res = [];
        const itemUniqueId = item.UniqueId.replaceAll("-", "");

        const attachItems = attachs.filter(x => ((x.CommentId || "").replaceAll("-", "") == itemUniqueId));
        attachItems.map(attachItem => {
            const attachments = (attachItem || {}).Attachs || [];
            attachments.map(x => {
                var attach = XPortal.Grid.MapEntity(x);
                const img = XPortal.Grid.ContentViewImageField(attach, { field: sttgs.attachdestinationfield, classes: [] }, sttgs.nodeid);
                return res.push({
                    html: img,
                    imgUrl: $(img).attr("src"),
                    isTypeImg: $(img).attr("data-is-img") === "true",
                    fileUrl: $(img).attr("data-dwl-src"),
                    commentId: x.relateduniqueid,
                    name: x[sttgs.attachnamefield],
                })
            });
        });
        return res;
    };

    function ensureActionRights(item, sttgs) {
        item.hidedelete = self.accountName != (item.memberusername || "").toLowerCase() && XPortal.Account.MemberName != (item.memberusername || "");
        item.hidenotify = true;
        item.hidereply = sttgs.readOnly;// || self.maxLevel < item.level;

        item.togglechildren = true;
        item.hidechildren = item.count < 1;
        return item;
    };

    function getTemplates(el, sttgs) {
        const templateIds = [];
        el.parent().find(".comment-cv-item").each(function (xi, x) {
            const _el$ = $(x);
            templateIds.push(_el$.attr("id"));
        });
        return templateIds;
    };
    function getModelToSend(sttgs, cmtext, parent, id) {
        return {
            parentId: parent, id, data: cmtext, nodeid: sttgs.data.nodeid, pageIndex: sttgs.data.pageIndex, parentInfo: sttgs.parentInfo
        };
    };
    function convertToHierarchy(items, sttgs) {
        const itop = items.filter(i => !items.find(ci => i.parentuniqueid == ci.UniqueId));
        const itemsToProcess = [];
        itop.forEach(i => itemsToProcess.push(i));
        while (itemsToProcess.length) {
            const sitem = itemsToProcess.pop();
            if (sitem.level - 2 < self.maxLevel) {
                const sitems = items.filter(i => i.parentuniqueid == sitem.UniqueId);
                sitem.SItems = sitems;
                sitem.count = sitems.length;
                ensureActionRights(sitem, sttgs);
                sitems.forEach(i => itemsToProcess.push(i));
            }
        }
        return itop;
    };
    function sendRequest(url, data) {
        return new Promise((onOk, onErr) => {
            XPortal.Utils.APIPost(url, { model: data }, { contentType: 'application/json' })
                .then(function (xdata) {
                    if (xdata.State < 0) onErr(xdata);
                    xdata.Result = xdata.Result || {};
                    xdata.Result.Items = xdata.Result.Items || [];
                    onOk(xdata);
                })
                .fail(function (...args) {
                    onErr(args);
                });
        });
    }
    function processAllPages(url, data, parent, onBatch) {
        //right now: only when all is loaded
        return new Promise((onOk, onErr) => {
            var items = [];
            function onNext(pageIndex) {
                data.pageIndex = pageIndex;
                sendRequest(url, data).then(data => {
                    if (parent != null) return onBatch(data);
                    if (data.Result.Items.length >= data.Result.TotalItems)
                        return onBatch(data);
                    else {
                        data.Result.Items.forEach(x => items.push(x));
                        if (data.Result.Items.length > 0 && items.length < data.Result.TotalItems)
                            return onNext(data.PageIndex + 1);
                        else {
                            data.Result.Items = items;
                            return onBatch(data);
                        };
                    }
                }, x => onErr(x));
            };
            onNext(data.pageIndex);
        });
    };
    function getFieldValue(sttgs, data, fsttgs) {
        if (sttgs && fsttgs) {
            var fname = fsttgs.field.toLowerCase();
            try {
                var format = fsttgs.formatString ? fsttgs.formatString.replaceAll(/\"/g, '\\"') : '';
                var gctdata = XPortal.Grid.GetTemplateValue(data, (fsttgs.type || "").toLowerCase(), encodeURIComponent(fname), encodeURIComponent(format), sttgs.nodeid);
                return $(gctdata).html();
            } catch (ex) {
                if (console) console.log("can't get field data error:" + ex, { sttgs, data, fsttgs });
            };
        }
        return XPortal.Template.GetObjPropValueByName(data, fsttgs.field);
    };
    /*--  avatar loading, refreshing  -- */
    function ensureAvatarsLoaded(el, sttgs, avatarsToLoad) {
        if (!avatarsToLoad.length) return;
        const data = getModelToSend(sttgs, "");
        data.names = avatarsToLoad;
        sendRequest(sttgs.urlavatars, data).then(data => {
            refreshAvatars(el, sttgs, data.Result.Items);
            if ($(".comments-cntbc.inited-show-more").length) handleShowMoreAppearance(el);
        }, errArgs => {
            console.log("can't load avatars, error", errArgs);
        });
    };
    function generateAvatar(item, name) {
        const isDarkTheme = document.body.classList.contains('theme-dark');
        const colors = {
            border: isDarkTheme ? '#626889' : '#EA6C3E',
            background: isDarkTheme ? '#414666' : '#FFEAE2',
            text: isDarkTheme ? '#DBE6F3' : '#EA6C3E',
        }
        const initials = (name || "").split(' ').map(function (str) { return str ? str[0].toUpperCase() : ""; });
        const text = initials.length < 3 ? initials.join('') : [initials[0], initials[initials.length - 1]].join('');
        const canvas = document.createElement('canvas');
        const radius = 30;
        const margin = 5;
        const borderWidth = 2;  // Define the border width
        canvas.width = (radius + margin + borderWidth) * 2;
        canvas.height = (radius + margin + borderWidth) * 2;

        // Get the drawing context
        const ctx = canvas.getContext('2d');

        // Draw the border
        ctx.beginPath();
        ctx.arc(radius + margin + borderWidth, radius + margin + borderWidth, radius + borderWidth, 0, 2 * Math.PI, false);
        ctx.closePath();
        ctx.fillStyle = colors.border;
        ctx.fill();

        // Draw the avatar background
        ctx.beginPath();
        ctx.arc(radius + margin + borderWidth, radius + margin + borderWidth, radius, 0, 2 * Math.PI, false);
        ctx.closePath();
        ctx.fillStyle = colors.background;
        ctx.fill();

        // Add the initials text
        ctx.fillStyle = colors.text;
        ctx.font = "400 30px Rubik";
        ctx.textAlign = 'center';
        ctx.fillText(text, radius + margin + borderWidth, radius * 4 / 3 + margin + borderWidth);

        return canvas.toDataURL();
    };
    function getAvatarOrInitials(item, avatarsToLoad) {
        let existing = self.avatars[item.memberusername];
        if (!existing) self.avatars[item.memberusername] = existing = { name: item.memberusername, data: null, loaded: false };
        if (!existing.data) existing.data = generateAvatar(item, item.memberusername);
        item.avatarLoaded = existing.loaded;
        if (!item.avatarLoaded) avatarsToLoad.push(item.memberusername);
        return item.avatar = "<img src='" + existing.data + "' ></img>";
    };
    function refreshAvatars(el, sttgs, aitems) {
        aitems.forEach(zii => {
            const zi = XPortal.Grid.MapEntity(zii, sttgs);
            const existing = self.avatars[zi.memberusername];
            if (!existing) return;
            existing.data = zi.avatar ? zi.avatar : existing.data;
            existing.loaded = true;
        });
        const items = [];
        sttgs.data.Items.forEach(i => items.push({ i, parent: null }));
        do {
            const iitem = items.pop();
            const item = iitem.i;
            const avtrIm = self.avatars[item.memberusername];
            if (avtrIm && avtrIm.data != item.avatar) {
                debug("refresh-avatar: " + item.memberusername, avtrIm);
                XPortal.Utils.updateKendoObj(item, { avatar: "<img src='" + avtrIm.data + "' ></img>" });
                refreshItems(iitem.parent ? iitem.parent.SItems : sttgs.data.Items, item);
            }
            item.SItems.forEach(i => items.push({ i, parent: item }));
        } while (items.length);
    };
    /*--  end --- avatar loading, refreshing  -- */
    function refreshItems(items, item) {
        let i = 0;
        for (i = 0; i < items.length; i++) {
            const iitem = items[i];
            if (iitem.UniqueId == item.UniqueId) break;
        }
        items.splice(i, 1, item);
    };
    function refreshItemsInTree(items, item) {
        if (!items || !item) return;
        const inTree = items.find(x => x.UniqueId == item.UniqueId);
        if (inTree) return refreshItems(items, item);
        items.forEach(i => {
            refreshItemsInTree(i.SItems, item);
        });
    };
    function linkifyComment(str) {
        return str.replace(self.urlRegex, function (url) {
            const href = url.match(/^https?:\/\//i) ? url : 'https://' + url;
            return "<a href='" + href + "' target='_blank' rel='noopener noreferrer'>" + url + "</a>";
        });
    };
    function findParent(items, item) {
        if (!items || !item) return;
        const inTree = items.find(x => x.UniqueId == item.UniqueId);
        if (inTree) return true;
        let result = null;
        for (let i = 0; i < items.length; i++) {
            result = findParent(items[i].SItems, item);
            if (result === true) return items[i];
            if (result) return result;
        }
        return result;
    };
    function autoHeight(elem) {
        const minHeight = 20;
        const el = elem[0];
        let clone = el._heightClone;
        if (!clone) {
            clone = el.cloneNode();
            clone.style.position = 'absolute';
            clone.style.visibility = 'hidden';
            clone.style.pointerEvents = 'none';
            clone.tabIndex = -1;
            clone.setAttribute('aria-hidden', 'true');
            clone.style.height = 'auto';
            el.parentNode.appendChild(clone);
            el._heightClone = clone;
        }
        clone.style.width = el.offsetWidth + 'px';
        clone.value = el.value;
        el.style.height = Math.max(minHeight, clone.scrollHeight) + 'px';
    };
    function getValueAndClear(e) {
        const el = $(e).closest(".cmnt-edit-form").find(".reply-control input, .reply-control textarea,.addnew-control input, .addnew-control textarea");
        const res = el.val();
        el.val("");
        autoHeight(el);
        return res;
    };
    function loadLocalizations() {
        self.accountName = (XPortal.Account.Name || "").toLowerCase();
        if (self.dictvals.processed) return;
        self.dictvals.processed = true;
        XPortal.Localization.GetLocalizedStrings(...self.dictkeys).then(items => {
            Object.keys(items).forEach(x => self.dictvals[x] = items[x]);
            self.dictvals["replytemplate"] = self.dictvals["XFAdvanceComments.Reply.Template"] == "XFAdvanceComments.Reply.Template" ? "@[[memberusername]]" : self.dictvals["XFAdvanceComments.Reply.Template"];
            self.dictvals["totaltemplate"] = self.dictvals["XFAdvanceComments.Total.Template"] == "XFAdvanceComments.Total.Template" ? "total comments amount - [[total]]" : self.dictvals["XFAdvanceComments.Total.Template"];
        }, (err) => { });
    }

    function waitForHeight(el, timeout = 2000) {
        return new Promise((resolve) => {
            const t0 = performance.now();

            const check = () => {
                const h =
                    el?.getBoundingClientRect?.().height ||
                    el?.offsetHeight ||
                    el?.scrollHeight ||
                    0;
                if (h > 0) return resolve(h);
                if (performance.now() - t0 >= timeout) return resolve(0);
                requestAnimationFrame(check);
            };

            check();
        });
    }
 
    
    async function handleShowMoreAppearance() {
      const $comments = $(self.controlSelector).find(
        ".comment .entity-fld-val"
      );

      $comments.each(async function () {
        const el = this;
        const h = await waitForHeight(el, 2000); 

        const sh = el.scrollHeight - 2;
        debug('h sh', h, sh);
        el.classList.toggle("show-btn", h > 0 && sh > h);
      });
    }

    function initAttachmentSlider(container) {
        const $sliders = $(container).find('.comment-attachments');

        $sliders.each(function () {
            const $slider = $(this);
            const isCarousel = $slider.parent('.comment-item__content-element').attr('data-is-carousel') == "True";
            const slidesCount = $slider.find('.comment-attachments__item').length;
            if ($slider.hasClass('slick-initialized')) return;

            if (!isCarousel) {
                $slider.addClass('comment-attachments_no-carousel');
                return;
            }

            if (slidesCount <= 3) {
                $slider.addClass('comment-attachments_no-carousel');
                return;
            }

            $slider.slick({
                variableWidth: false,
                infinite: false,
                autoplay: false,
                useTransform: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: true,
                arrows: true,
                prevArrow: "<span class='slider-arrow slider-prev'><i class='icon-arrow-left'></i></span>",
                nextArrow: "<span class='slider-arrow slider-next'><i class='icon-arrow-right'></i></span>",
            });
        })
    };

    function showEmtyCommentError(el) {
        let $inputWrp = $(el).closest(".cmnt-edit-form").find(".addnew-control, .reply-control");
        clearEmtyCommentError(el);
        XPortal.Localization.GetLocalizedStrings('XFAdvanceComments.ErrorAddEmptyComment').then(function (items) {
            let dictionaryErrorMessage = items["XFAdvanceComments.ErrorAddEmptyComment"];
            $inputWrp.append(`<div class="field-validation-error"> ${dictionaryErrorMessage} </div>`);
        });
    };

    function clearEmtyCommentError(el) {
        $(el).closest(".cmnt-edit-form").find(".field-validation-error").remove();
    };

    function debug(m, o) {
        //if (console) console.log(m, o);
    };
    return self;
}());
